import { render, staticRenderFns } from "./BasicInfoIframe.vue?vue&type=template&id=3c0766cd&"
import script from "./BasicInfoIframe.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports